/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import { Button, Form, Image } from 'semantic-ui-react'
import cx from 'classnames'
import isEmail from 'validator/es/lib/isEmail'
import isLength from 'validator/es/lib/isLength'
import { useTranslation } from 'react-i18next'
import isEmpty from 'validator/es/lib/isEmpty'

import img from '../../images/spectro.jpeg'
import styles from './login.module.css'
import { AuthUser } from '../../services/auth'
import IntelMsg from '../ItelMsg/index'
import { secondaryColor } from '../../constants'

export default function Login() {
  const [validMail, setValidMail] = useState(true)
  const [emptyMail, setEmptyMail] = useState(false)
  const [validPassword, setValidPassword] = useState(true)
  const [emptyPassword, setEmptyPassword] = useState(false)
  const [isLoginFail, setIsLoginFail] = useState(false)
  const [isInactive, setIsInactive] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [disableSubmit, setDisableSubmit] = useState(false)

  const { t } = useTranslation()

  async function onSubmit(e) {
    e.preventDefault()
    setEmptyMail(isEmpty(email))
    const isValidMail = isEmail(email)
    setValidMail(isValidMail)

    const isValidPassword = isLength(password, { min: 8, max: 64 })
    setValidPassword(isValidPassword)
    setEmptyPassword(isEmpty(password))

    if (isValidMail && isValidPassword) {
      setDisableSubmit(true)
      setIsLoginFail(false)
      setIsInactive(false)
      const response = await AuthUser(email.toLowerCase(), password)
      if (response.status === 403) {
        setIsInactive(true)
        setIsLoginFail(false)
        setDisableSubmit(false)
      } else if (response.status === 401) {
        setIsInactive(false)
        setIsLoginFail(true)
        setDisableSubmit(false)
      }
      console.log(response)
      console.log('')
    }
  }
  return (
    <div className={styles.authWrapper}>
      <div className={styles.authInner}>
        <Image src={img} size="small" className={styles.logo} />

        <Form noValidate widths="equal">
          <div className={styles.header}>
            <h3>
              <IntelMsg id="formHeader" />
            </h3>
          </div>
          <Form.Field>
            <label htmlFor="email">
              <IntelMsg id="formEmailLabel" />
            </label>
            <input
              id="email"
              type="email"
              className="form-control"
              placeholder={t('emailInputPlaceholder')}
              onChange={(e) => setEmail(e.target.value)}
            />
            {emptyMail ? (
              <small className={cx(styles.invalid)}>
                {emptyMail ? `${t('required')}` : '**'}
              </small>
            ) : (
              <small className={cx(styles.invalid)}>
                {!validMail ? `${t('emailErrorMessage')}` : '**'}
              </small>
            )}
          </Form.Field>

          <Form.Field>
            <label htmlFor="password">
              <IntelMsg id="formPasswordLabel" />
            </label>
            <input
              id="password"
              type="password"
              className="form-control"
              placeholder={t('passwordInputPlaceholder')}
              onChange={(e) => setPassword(e.target.value)}
            />
            {emptyPassword ? (
              <small className={cx(styles.invalid)}>
                {emptyPassword ? `${t('required')}` : '**'}
              </small>
            ) : (
              <small className={cx(styles.invalid)}>
                {!validPassword ? `${t('passwordErrorMessage')}` : '**'}
              </small>
            )}
          </Form.Field>

          <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                className="custom-control-input"
                id="customCheck1"
              />
              <strong>
                &nbsp; <IntelMsg id="rememberMeLabel" />
              </strong>
            </div>
          </div>

          <div style={{ textAlign: 'center' }}>
            <Button
              style={{ backgroundColor: secondaryColor, color: 'white' }}
              size="large"
              type="submit"
              onClick={(e) => onSubmit(e)}
              disabled={disableSubmit}
            >
              <IntelMsg id="loginSubmitButton" />
            </Button>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <p>
              <IntelMsg id="forgetPassword" />
            </p>
          </div>
          <strong className={cx(styles.invalid)}>
            {isLoginFail === true
              ? `${t('formErrorMessage')}`
              : isInactive === true
              ? `${t('formInactiveErrorMessage')}`
              : ''}
          </strong>
        </Form>
      </div>
    </div>
  )
}
